export default __webpack_public_path__ + "static/media/multiselect.28957cb2.svg";